import PublicHeader from 'layout/PublicLayout/PublicHeader';
import React, { useEffect } from 'react';
import Login from 'containers/Login';
import { useSelector } from '@redux';
import { useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate('/');
    }
  }, [token]);
  
  return (
    <div>
      <PublicHeader title='common.auth.loginSub' />
      <Login />
    </div>
  );
}
